import { render, staticRenderFns } from "./ManualCreateFood.vue?vue&type=template&id=4d074616&"
import script from "./ManualCreateFood.vue?vue&type=script&lang=js&"
export * from "./ManualCreateFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports